import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { DocumentoService } from 'src/app/services/documento.service';
import * as _ from 'lodash';
import { filter } from 'rxjs/operators';
import { element } from 'protractor';

@Component({
  selector: 'app-modal-imprimir-factura-detalle',
  templateUrl: './modal-imprimir-factura-detalle.component.html',
  styleUrls: ['../imprimir-factura.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class ImprimirFacturaDetalleComponent implements OnInit {
  private client: GraphQLClient = null;

  // Modales
  @ViewChild('imprimirFacturaDetalle', { static: true }) imprimirFacturaDetalleModal: ModalDirective;

  formPrecioCosto: FormGroup;

  public rutEmpresa: number;
  public sucursalEmpresa: Number;
  dataCabecera: any = null;
  dataDetalle: any;
  totalesDocumento: any = null;

  //Cabecera
  folio: number = 0;
  clienteRut: string = '';
  clienteNombre: string = '';
  direccion: string = '';
  fechaEmision: Date;
  direccionNombre: Date;
  vendedorNombre: Date;
  listaMovimientos: Array<any> = null;

  // Utils
  private log: any;

  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private rutService: RutService,
    private documentoService: DocumentoService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService
  ) {
    this.client = client;
    this.log = this.clog.log('IMPRIMIR-FACTURA-DETALLE-VIEW');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
  }

  loadAndShow(documento) {
    // this.productoCodigoOriginal = producto_codigo
    // this.precioCostoOriginal = precio_costo
    this.selectData(documento);
    this.show();
  }

  show() {
    //this.isEditing = false
    this.clearData();
    this.imprimirFacturaDetalleModal.show();
  }

  hide() {
    this.imprimirFacturaDetalleModal.hide();
  }
  clearData() {
    //this.formValidatorsService.reset(this.formPrecioCosto)
  }

  public executeQueryBuscarDocumentoByFolio({ folio, tipo_dte_codigo, cliente_proveedor_rut }, callback: Function) {
    const inputParams = {
      rut_emisor: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
      folio,
      tipo_dte_codigo: tipo_dte_codigo, // TODO: Dummy data
      es_nc: false,
      es_nd: false,
    };

    this.log('inputParams', JSON.stringify(inputParams));
    const self = this;
    this.client.query(
      {
        query: gql`
          query ($rut_emisor: Decimal, $sucursal_codigo: Decimal, $folio: Decimal, $tipo_dte_codigo: Decimal, $es_nc: Boolean, $es_nd: Boolean) {
            documento {
              obtenerDocumentoVisorImpresion(
                filtro: { exacto: { cabecera: { rut_emisor: $rut_emisor, sucursal_codigo: $sucursal_codigo, folio: $folio, tipo_dte_codigo: $tipo_dte_codigo, es_nc: $es_nc, es_nd: $es_nd } } }
              ) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  cabecera {
                    rut_emisor
                    sucursal_codigo
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    tipo_envio_codigo
                    tipo_traslado_codigo
                    condicion_pago_codigo
                    vendedor_codigo
                    tipo_devolucion_codigo
                    fecha_emision
                    rut_receptor
                    direccion_completa_facturacion
                    comuna_facturacion
                    provincia_facturacion
                    region_facturacion
                    direccion_completa_despacho
                    comuna_despacho
                    princia_despacho
                    region_despacho
                    giro_cliente
                    fono_cliente
                    monto_descuento
                    monto_recargo
                    subtotal_neto
                    monto_total_neto
                    monto_iva
                    monto_afecto
                    monto_exento
                    subtotal
                    monto_total
                    nota_venta
                    orden_compra
                    fecha_registro
                    aplica_rebaja
                    aplica_recorrido
                    observaciones
                    ticket_sii
                    fecha_vencimiento
                    dia_emision
                    mes_emision
                    id_lsoft
                    motivo_devolucion_codigo
                    tipo_despacho_codigo
                    centro_costo_codigo
                    forma_pago_codigo
                    tipo_destinatario_codigo
                    es_entrega_gratuita
                    direccion_codigo
                    usuario_rut_usuario
                    tipo_ncnd_codigo
                    glosa_administrativa
                    cliente_nombre
                    vendedor_nombre
                    direccion_nombre
                    tipo_dte_nombre
                    es_nc
                    es_nd
                  }
                  descuentosGlobales {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    es_porcentaje
                    monto_descuento
                    es_descuento
                    glosa
                    ind_facturacion
                    es_exento
                  }
                  detalleDocumento {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    formato_codigo
                    formato_nombre
                    descripcion_producto
                    cantidad
                    precio_neto
                    precio_unitario
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    es_exento
                    gasto_codigo
                    equivalencia_producto_id
                    sku
                    motivo_devolucion_especifico_codigo
                    es_correcion_monto
                    aplicacion_descuento
                    aplicacion_recargo
                    aplicacion_imp_adic
                    no_aplica_descuento
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (_respuesta) {
        const { mensajes, respuesta } = _respuesta.data.documento.obtenerDocumentoVisorImpresion;
        const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
        if (!ok) {
          self.messageRendererService.showErrors(mensajes);
          callback(null);
          return;
        }

        delete respuesta.__typename;

        // const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
        // callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros))
        callback(respuesta);
      }
    );
  }

  // Se consume desde la vista
  selectData(documento) {
    this.executeQueryBuscarDocumentoByFolio(documento, (result: any) => {
      if (result) {
        this.emitirSeleccionado(result);
        //this.hide()
      }
    });
  }
  emitirSeleccionado(data) {
    this.dataCabecera = data.cabecera; //.cabecera
    this.dataDetalle = data.detalleDocumento;
    this.setCabeceraOriginales(this.dataCabecera);
    this.setDetallesOriginales(this.dataDetalle);
    this.ObtenerTotales(data);
    //this.loadComboTipoNotaCredito()
  }

  private setCabeceraOriginales(data) {
    this.folio = data.folio;
    this.clienteRut = this.rutService.AgregarDV(data.cliente_proveedor_rut);
    this.clienteNombre = data.cliente_nombre;
    this.fechaEmision = data.fecha_emision;
    this.direccionNombre = data.direccion_completa_facturacion;
    this.vendedorNombre = data.vendedor_nombre;

    this.log('inputParams', JSON.stringify(this.fechaEmision));
  }

  private setDetallesOriginales(detalle) {
    this.listaMovimientos = detalle;
  }

  ObtenerTotales(data) {
    this.FetchObtenerTotales(data, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.totalesDocumento = respuesta;
    });
  }

  //Obtener totales de documento
  FetchObtenerTotales(data, callback: Function) {
    //this.log('FetchObtenerTotales this.dataCabecera', this.dataCabecera)
    const dataDetalle = data.detalleDocumento.filter((x) => x.es_correcion_monto);
    const esCorreccionMonto = dataDetalle.length > 0;
    const inputParams = {
      entidadDTO: {
        cabecera: {
          rut_emisor: data.cabecera.tipo_dte_codigo == 46 ? data.cabecera.rut_emisor : this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          cliente_proveedor_rut: data.cabecera.cliente_proveedor_rut,
          direccion_codigo: data.cabecera.direccion_codigo,
          tipo_ncnd_codigo: data.cabecera.tipo_ncnd_codigo,
          es_correcion_monto: esCorreccionMonto,
          es_nc: data.cabecera.es_nc,
          es_nd: data.cabecera.es_nd,
          tipo_dte_codigo: data.cabecera.tipo_dte_codigo,
          rut_receptor: data.cabecera.rut_receptor,
        },
        descuentosGlobales: this.cleanDescuentosGlobales(data.descuentosGlobales),
        detalleDocumento: this.cleanDetalledocumento(data.detalleDocumento),
      },
    };
    this.log('inputParams', JSON.stringify(inputParams));
    this.documentoService.ObtenerTotalesDocumento(inputParams, callback);
  }

  private cleanDetalledocumento(detalleDocumento) {
    // let _detalledocumento = [...detalleDocumento]
    // let _detalledocumento = [];
    // detalleDocumento.forEach(val => _detalledocumento.push(Object.assign({}, val)));
    let _detalledocumento = _.cloneDeep(detalleDocumento);
    _detalledocumento.forEach((p) => {
      //delete p.additionalInfo
      delete p.__typename;
      p.aplicacion_descuento = 0;
      p.aplicacion_recargo = 0;
      p.aplicacion_imp_adic = 0;
      p.seleccion = true;
      if (p.atributos)
        p.atributos.forEach((attr) => {
          delete attr.__typename;
        });
    });
    return _detalledocumento;
  }
  private cleanDescuentosGlobales(descuentosGlobales) {
    // let _detalledocumento = [...detalleDocumento]
    // let _detalledocumento = [];
    // detalleDocumento.forEach(val => _detalledocumento.push(Object.assign({}, val)));
    let _descuentoglobales = _.cloneDeep(descuentosGlobales);
    _descuentoglobales.forEach((p) => {
      //delete p.additionalInfo
      delete p.__typename;
      // if (p.atributos)
      //   p.atributos.forEach(attr => {
      //     delete attr.__typename
      //   })
    });
    return _descuentoglobales;
  }
}
